import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Factura } from './Factura';
import { FacturaDetalle } from './FacturaDetalle';
import { environment } from '../environments/environment';
import { VVentas } from './VVentas';
import { FacturaXls } from './FacturaXls';
import { ventasDia } from './ventasDia';
import { Peso } from './peso';
import { Catalogo } from './catalogo';


@Injectable({
  providedIn: 'root'
})
export class CatalogoService {



  
  constructor(private http: HttpClient) { }

  listarCatalogo(idEmisor,tabla){
    return this.http.get<Catalogo[]>(environment.apiUrl+"/listarCatalogo/?idEmisor="+idEmisor+"&tabla="+tabla);
  }

}